import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import BonRetourLivreur from '@/features/bon-retour-livreur'

export const Route = createFileRoute('/_authenticated/bon-retour-livreur/')({
  component: BonRetourLivreur,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Bon Retour Livreur`,
      },
    ],
  }),
})
